export function ensureOrgSlugInSearchSuffix(searchSuffix: string, orgSlug: string): string {
  const suffix = searchSuffix.startsWith('?') ? searchSuffix.slice(1) : searchSuffix;
  const params = new URLSearchParams(suffix);
  if (!params.get('org_slug')?.trim() && !params.get('org')?.trim()) {
    params.set('org_slug', orgSlug);
  }
  const next = params.toString();
  return next ? `?${next}` : '';
}
